
import { SpinnerService } from './services/spinner.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './menu/header.component';
import { FooterComponent } from './menu/footer.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { homelayoutcomponent } from './layout/homelayout.component';
import { AppComponent } from './app.component';
import { ProductSubcategoryComponent } from './productsubcategory/productsubcategory.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { PrintgroupsComponent } from './printgroups/printgroups.component';
import { SpecpageComponent } from './specpage/specpage.component';
import { ProductCategoryService } from './services/productcategory.service';
import { NomenclatureComponent } from './nomenclature/nomenclature.component';
import { CasepackComponent } from './casepack/casepack.component';
import { NgxPaginationModule} from 'ngx-pagination';
import { CompatibleitemComponent } from './compatibleitem/compatibleitem.component';
import { MaterialComponent } from './material/material.component';
import { PrintgroupComponent } from './printgroup/printgroup.component';
import { ProductComponent } from './product/product.component';
import { CategoryComponent } from './category/category.component';
import { AlertService } from './services/alert.service';
import { ToastrModule } from 'ngx-toastr';
import { SubcategoryComponent } from './subcategory/subcategory.component';
//import { AuthService } from './security/auth.service';
//import { AuthGuard } from './security/auth.guard';
import { AngularWebStorageModule } from 'angular-web-storage';
import { LoginComponent } from './menu/login.component';
import { LogoutComponent } from './menu/logout.component';
//import { AuthenticateService } from './services/authenticate.service';
import { CustomAuthInterceptor } from './services/custom-auth.interceptor';
import { HTTP_INTERCEPTORS} from '@angular/common/http';
import { loginlayoutcomponent } from './layout/loginlayout.component';
import { AccessdeniedComponent } from './accessdenied/accessdenied.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchresultsComponent } from './searchresults/searchresults.component';
import { ExcelService } from './services/excel.service';
import { ProductpdfComponent } from './productpdf/productpdf.component';
import { StringFilterPipe } from './shared/string-filter.pipe';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DataInsertComponent } from './data-insert/data-insert.component';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { msalConfig, loginRequest, protectedResources } from './auth-config';
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map < string,
      Array < string >> ();
  protectedResourceMap.set(protectedResources.ACESApi.endpoint+"Product", protectedResources.ACESApi.scopes);
  protectedResourceMap.set(protectedResources.ACESApi.endpoint+"CasePack", protectedResources.ACESApi.scopes);
  protectedResourceMap.set(protectedResources.ACESApi.endpoint+"Material", protectedResources.ACESApi.scopes);
  protectedResourceMap.set(protectedResources.ACESApi.endpoint+"PrintGroup", protectedResources.ACESApi.scopes);
  protectedResourceMap.set(protectedResources.ACESApi.endpoint+"CompatibleItem", protectedResources.ACESApi.scopes);

  return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap
  };
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
      interactionType: InteractionType.Redirect,
      authRequest: loginRequest
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LandingpageComponent,
    homelayoutcomponent,
    ProductSubcategoryComponent,
    PrintgroupsComponent,
    SpecpageComponent,
    NomenclatureComponent,
    CasepackComponent,
    CompatibleitemComponent,
    MaterialComponent,
    PrintgroupComponent,
    ProductComponent,
    CategoryComponent,
    SubcategoryComponent,
    LoginComponent,
    LogoutComponent,
    loginlayoutcomponent,
    AccessdeniedComponent,
    SearchresultsComponent,
    ProductpdfComponent,
    StringFilterPipe,
    DataInsertComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxPaginationModule,
    ToastrModule.forRoot(),
    AngularWebStorageModule,
    NgxSpinnerModule,
    CKEditorModule,
    MsalModule
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],

  providers: [ { 
    provide: HTTP_INTERCEPTORS,    
    useClass: MsalInterceptor, 
    multi: true },{
      provide: HTTP_INTERCEPTORS,
      useClass: CustomAuthInterceptor,
      multi: true,
    },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
}, {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory
}, {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
},
           //   AuthService,
          //    AuthenticateService ,
              MsalService,
              MsalGuard,
              MsalBroadcastService,
              ProductCategoryService,
              AlertService,
              ExcelService,            
             ],
  bootstrap: [AppComponent,MsalRedirectComponent]
})
export class AppModule { }

